// 画像アップロード共通ユーティリティ。
// editor_controller / slash_menu などから呼び出す。

const MAX_BYTES = 20 * 1024 * 1024  // 20MB (controller 側と揃える)

export function isImageFile(file) {
  return file && typeof file.type === "string" && file.type.startsWith("image/")
}

// CSRF token (Rails) を <meta name="csrf-token"> から取得
function csrfToken() {
  const meta = document.querySelector('meta[name="csrf-token"]')
  return meta?.getAttribute("content") || ""
}

// <input type="file" accept="image/*"> を開いて選択された 1 ファイルを onPick に渡す。
// editor_controller / slash_menu / block_commands から共通利用。
export function pickImageFile(onPick) {
  const input = document.createElement("input")
  input.type   = "file"
  input.accept = "image/*"
  input.style.display = "none"
  input.addEventListener("change", () => {
    const f = input.files?.[0]
    if (f && isImageFile(f)) onPick(f)
    input.remove()
  })
  document.body.appendChild(input)
  input.click()
}

// POST /spaces/:slug[/pages/:id]/attachments  (multipart/form-data)
// 戻り値: { ulid, filename, url, content_type, size, is_image }
export async function uploadImage(file, endpoint) {
  if (!isImageFile(file)) {
    throw new Error("画像ファイルのみアップロードできます")
  }
  if (file.size > MAX_BYTES) {
    throw new Error(`ファイルが大きすぎます (上限 ${MAX_BYTES / 1024 / 1024}MB)`)
  }

  const form = new FormData()
  form.append("file", file)

  const res = await fetch(endpoint, {
    method: "POST",
    headers: {
      "X-CSRF-Token": csrfToken(),
      "Accept":       "application/json",
    },
    body:        form,
    credentials: "same-origin",
  })

  if (!res.ok) {
    let msg = `アップロード失敗 (HTTP ${res.status})`
    try {
      const body = await res.json()
      if (body?.error) msg = body.error
    } catch (_) {}
    throw new Error(msg)
  }

  return res.json()
}

// 画像に限らない汎用アップロード (.drawio XML 等)。controller は content_type を問わない。
// 戻り値: { ulid, filename, url, content_type, size, is_image }
export async function uploadFile(file, endpoint) {
  if (file.size > MAX_BYTES) {
    throw new Error(`ファイルが大きすぎます (上限 ${MAX_BYTES / 1024 / 1024}MB)`)
  }
  const form = new FormData()
  form.append("file", file)

  const res = await fetch(endpoint, {
    method: "POST",
    headers: { "X-CSRF-Token": csrfToken(), "Accept": "application/json" },
    body: form,
    credentials: "same-origin",
  })
  if (!res.ok) {
    let msg = `アップロード失敗 (HTTP ${res.status})`
    try { const b = await res.json(); if (b?.error) msg = b.error } catch (_) {}
    throw new Error(msg)
  }
  return res.json()
}

// drawio export の dataURI (data:image/png;base64,...) を Blob 化。
export function dataUriToBlob(dataUri) {
  const [head, b64] = String(dataUri).split(",", 2)
  if (b64 == null) return null
  const mime = head.match(/data:([^;]+)/)?.[1] || "application/octet-stream"
  const bin = atob(b64)
  const bytes = new Uint8Array(bin.length)
  for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i)
  return new Blob([bytes], { type: mime })
}
